import type { VmSpec } from './schema';

export const vmMigrations: Record<number, (data: unknown) => VmSpec> = {};
